/**
 * Created by renjie.huang on 2017/12/5.
 */

var route = {
    path : '/logout',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            cb(null, require('../pc/Logout.jsx').default)
        }, 'home')
    }
}


export default route;


// WEBPACK FOOTER //
// ./src/routes/logout.js